export default function () {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_93506)">
                <path
                    d="M27.8 6H4.2C3.53726 6 3 6.53726 3 7.2V21.8C3 22.4627 3.53726 23 4.2 23H27.8C28.4627 23 29 22.4627 29 21.8V7.2C29 6.53726 28.4627 6 27.8 6Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.6 9H6.4C6.17909 9 6 9.17909 6 9.4V19.6C6 19.8209 6.17909 20 6.4 20H25.6C25.8209 20 26 19.8209 26 19.6V9.4C26 9.17909 25.8209 9 25.6 9Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 25.7988L8.5 23.2008" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.5 25.7988L24 23.2008" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7177_93506">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
